module.exports = __webpack_public_path__ + "img/mail.d9749637.svg";